import { Controller } from "@hotwired/stimulus";

// Says whether a grid's photographs are mostly portrait, once they have
// loaded: Shopify hands a product photo's address, not its shape, and a
// portrait ring cropped into a landscape cell showed only a band across its
// middle (report 1581). The stylesheet lays the grid out by the answer.
//
// Decided once, on the whole set: deciding as each photo landed would swap
// the layout back and forth while the slide filled. A deferred photo has no
// `src` until the deck reaches its board, so the set is complete only when
// every photo has one and has finished, loaded or broken. `load` and `error`
// do not bubble, so they are caught on the way down; a set already in place
// (cached, or a deck printed with every photo loaded) is measured on connect.
export default class extends Controller {
  connect() {
    this.measure = this.measure.bind(this);
    this.element.addEventListener("load", this.measure, true);
    this.element.addEventListener("error", this.measure, true);
    this.measure();
  }

  disconnect() {
    this.stopListening();
  }

  measure() {
    const images = [...this.element.querySelectorAll("img")];
    if (
      images.length === 0 ||
      images.some((img) => !img.getAttribute("src") || !img.complete)
    )
      return;

    const loaded = images.filter((img) => img.naturalWidth > 0);
    if (loaded.length > 0) {
      const portrait = loaded.filter(
        (img) => img.naturalHeight > img.naturalWidth * 1.05,
      ).length;
      this.element.dataset.orientation =
        portrait * 2 > loaded.length ? "portrait" : "landscape";
    }
    this.stopListening();
  }

  stopListening() {
    this.element.removeEventListener("load", this.measure, true);
    this.element.removeEventListener("error", this.measure, true);
  }
}
